import styled from "styled-components";

export const CharacterCounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;
  gap: 0.5rem;

  span {
    height: 20px;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    font: 700 0.7rem "Roboto", sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};

    span {
      color: #fff;
    }
  }
`;

export const ProgressBar = styled.div`
  height: 10px;
  border-radius: 5px;
  background-color: ${({ theme }: {theme: any}) => theme.themeLight};
  overflow: hidden;
`;

export const Progress = styled.div`
  height: 100%;
  border-radius: 5px;
  background-color: ${({ theme }: {theme: any}) => theme.themePrimary};
`;
